import { dateFormat } from '@carm/shared/constants/const-carm';
import * as dayjs from 'dayjs';
import { ISimaDraft } from '../api';
import { ISimaForm } from '../form';

export const mapCADSimaToSimaForm = (cadSimaData: ISimaDraft): ISimaForm => {
  return {
    antidumpingSima: cadSimaData.simaAntiDumping,
    cashBond: cadSimaData.simaCashBondFlag,
    selfDeclare: cadSimaData.ignoreSimaCalFlag,
    countervailingSima: cadSimaData.simaCountervailing,
    invoicePriceCurrency: cadSimaData.simaInvoicePriceCurr,
    invoicePrice: cadSimaData.simaInvoicePrice,
    exportDeductionCurrency: cadSimaData.simaExpDeductionCurr,
    exportDeductionPrice: cadSimaData.simaExpValueDeducAmount,
    incoTerms: cadSimaData.simaIncoterms,
    uniqueProductId: cadSimaData.simaUniqueProductID,
    exporterId: cadSimaData.simaExportId,
    dateOfSale: cadSimaData.simaDateOfSale ? dayjs(cadSimaData.simaDateOfSale, dateFormat).toDate() : null,
    unitOfMeasure: cadSimaData.simaUOM,
    measureInForce: cadSimaData.simaUOMForce,
    simaCode: cadSimaData.simaCode,
    simaQuantity: cadSimaData.simaQuantity,
    simaSubject: cadSimaData.simaSubject,
  };
};

export const mapSimaFormToCADSima = (simaForm: ISimaForm): ISimaDraft => {
  return {
    simaAntiDumping: simaForm.antidumpingSima,
    simaCashBondFlag: simaForm.cashBond,
    simaCountervailing: simaForm.countervailingSima,
    simaInvoicePriceCurr: simaForm.invoicePriceCurrency,
    simaInvoicePrice: simaForm.invoicePrice,
    simaExpDeductionCurr: simaForm.exportDeductionCurrency,
    simaExpValueDeducAmount: simaForm.exportDeductionPrice,
    simaIncoterms: simaForm.incoTerms,
    simaUniqueProductID: simaForm.uniqueProductId,
    simaExportId: simaForm.exporterId,
    simaDateOfSale: simaForm.dateOfSale ? dayjs(simaForm.dateOfSale).format(dateFormat) : null,
    simaUOM: simaForm.unitOfMeasure,
    simaUOMForce: simaForm.measureInForce,
    simaCode: simaForm.simaCode,
    simaQuantity: simaForm.simaQuantity,
    simaSubject: simaForm.simaSubject,
    ignoreSimaCalFlag: simaForm.selfDeclare,
  };
};
